import React from "react";
import PrivacyPolicy from "../components/PrivacyPolicy";

function PrivacyPolicyPage() {
  return <PrivacyPolicy />;
}

export default React.memo(PrivacyPolicyPage);
